import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ページ遷移時にスクロール位置を先頭へ戻す。
 * ハッシュ付きのリンク（例: /#contact）の場合は、
 * 各ページ側で対象セクションへ移動する処理にまかせる。
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}